function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { classnames } from '@bydesign-ui/utils';
import { useRefCallback } from '@bydesign-ui/hooks';
import { FormProvider, ScopeProvider, useCreateForm } from '../../hooks/form';
export function Form(props) {
  var children = props.children,
      className = props.className,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? false : _props$inline,
      form = props.form,
      onSubmit = props.onSubmit,
      onSubmitFailed = props.onSubmitFailed,
      onModelChange = props.onModelChange,
      onValuesChange = props.onValuesChange,
      defaultModel = props.defaultModel,
      _props$vertical = props.vertical,
      vertical = _props$vertical === void 0 ? false : _props$vertical,
      extra = _objectWithoutProperties(props, ["children", "className", "inline", "form", "onSubmit", "onSubmitFailed", "onModelChange", "onValuesChange", "defaultModel", "vertical"]);

  var onModelChangeCallback = useRefCallback(onModelChange);
  var onSubmitCallback = useRefCallback(onSubmit);
  var onValuesChangeCallback = useRefCallback(onValuesChange);
  var onSubmitFailedCallback = useRefCallback(onSubmitFailed);
  var cls = classnames(usePrefixCls('form', {
    inline: inline,
    vertical: vertical
  }), className);
  var ins = useCreateForm({
    form: form,
    defaultModel: defaultModel,
    onModelChange: onModelChangeCallback,
    onValuesChange: onValuesChangeCallback,
    onSubmit: onSubmitCallback,
    onSubmitFailed: onSubmitFailedCallback
  });
  var onFormSubmit = useCallback(function (e) {
    e.preventDefault();
    ins.submit();
  }, []);
  var onFormReset = useCallback(function (e) {
    e.preventDefault();
    ins.reset();
  }, []);
  return React.createElement(FormProvider, {
    value: ins
  }, React.createElement(ScopeProvider, {
    value: ins.getRootNode()
  }, React.createElement("form", Object.assign({}, extra, {
    className: cls,
    noValidate: true,
    onReset: onFormReset,
    onSubmit: onFormSubmit
  }), children)));
}